import { truthy } from '../../utils';
import type { State } from '../types';
import { formatPricingPlansForStore } from './format-pricing-plans';

export const getOfferingAndPricingPlanMapForStore = (listItems: any) => {
  const productIdPricingPlanMap: State['offeringsAndpricingPlans'] = {};

  listItems.forEach((product: any) => {
    const { id, offering } = product;

    const nonEmptyOfferings = offering?.filter(truthy) || [];
    const availableOfferings = nonEmptyOfferings.map((offering: any) => {
      const {
        id,
        availablePricingPlans,
        offeringName,
        level,
        pricingType,
        trialLengthInDays,
        offeringGroup,
        relationshipRequirements,
      } = offering;

      const { defaultPricingPlan, USDPricingPlanEligibility, pricingPlans } = formatPricingPlansForStore({
        availablePricingPlans,
      });

      return {
        id,
        offeringName,
        level,
        pricingType,
        offeringGroup,
        relationshipRequirements,
        defaultPricingPlan: {
          id: defaultPricingPlan?.id || '',
        },
        defaultPricingPlansEligibilityMap: USDPricingPlanEligibility,
        trialLengthInDays,
        pricingPlans,
      };
    });
    productIdPricingPlanMap[id] = availableOfferings;
  });
  return productIdPricingPlanMap;
};
